<template> 
  <div class="project-overview project-wampper bg071129">
    <div class="content-left">
      <div class=" progress-left">
        <div class="title-bg overviwe-title">
          工程进度
        </div>
        <div class="public-bg progress-state">
          <div class="progress-word">
            <p class="font-FFFFFF-50">面积： </p>
            <p class="font-size-22 font-family-AR">{{$project.projectData.area}} </p>
            <p class="font-FFFFFF-50">工程倒计时： </p>
            <p class="font-22 font-FFB224 font-family-AR">{{countDay}} 天 </p>
          </div>
          <div class="progress-echart" v-if="seriesDataBallShow">
            <WaterBall
                ref="waterBall"
                class="margin-bottom-10"
                :seriesData='seriesDataBall' 
                :borderWidth='14'
                :BallIndex='20'
                :bSize="133"
                >
            </WaterBall>
          </div>
        </div>
        <div v-if="projectKey == '1'">
          <progressTab :arrayTwo="arrayTwo"></progressTab>
        </div>
        <div class="title-bg overviwe-title title-bg-130">
          进度滞后原因
        </div>
        <div class="public-bg progress-lag" :class="projectKey != '1' ? 'bg-height-230' : ''">
          <ul>
            <vue-seamless-scroll :data="lagList" class="seamless-warp" :class-option="classOption">
              <li class="font-FFFFFF-50" v-for="(item,index) in lagList" :key="index">
                <span class="list-num">{{index+1}}.</span>{{item}}
              </li>
            </vue-seamless-scroll>
          </ul> 
        </div>
        <div class="title-bg overviwe-title">
          进度日报
        </div>
        <div class="public-bg progress-lag project-finish" :class="projectKey != '1' ? 'bg-height-230' : ''">
          <div class="lag-list-title">
            <el-row>
              <el-col :span="16">
                <span class="font-26ABFF">任务简称</span>
              </el-col>
              <el-col :span="8">
                <span class="font-26ABFF">完成量</span>
              </el-col>
            </el-row>
          </div>
          
          <ul v-if="finishList.length > 5">
            <vue-seamless-scroll :data="finishList" class="seamless-warp" :class-option="classOption">
              <li 
                class="font-FFFFFF-50" 
                v-for="(item,index) in finishList"
                :key="index">
                <el-row>
                  <el-col :span="16">
                    {{item.Progress_taskname || '----'}}
                  </el-col>
                  <el-col :span="8"> 
                    <span class="font-26ABFF fontweight font-family-AR font-width">{{item.Progress_actualratio}}%</span>
                    <el-progress 
                      class="finish-loading finish-loading-actual" 
                      :show-text="false"  
                      :text-inside="true" 
                      color="#26abff" 
                      :stroke-width="10" 
                      :percentage="item.LastProgress_actualratio">
                    </el-progress>
                    <el-progress 
                      class="finish-loading finish-loading-lastactual" 
                      :show-text="false"  
                      :text-inside="true" 
                      color="#ffb224" 
                      :stroke-width="10" 
                      :percentage="item.Progress_actualratio">
                    </el-progress>
                  </el-col>
                </el-row>
              </li>
            </vue-seamless-scroll>
          </ul>
          <ul v-else>
            <li 
              class="font-FFFFFF-50" 
              v-for="(item,index) in finishList"
              :key="index">
              <el-row>
                <el-col :span="16">
                  {{item.Progress_taskname || '----'}}
                </el-col>
                <el-col :span="8"> 
                  <span class="font-26ABFF fontweight font-family-AR font-width">{{item.Progress_actualratio}}%</span>
                  <el-progress 
                    class="finish-loading finish-loading-actual" 
                    :show-text="false"  
                    :text-inside="true" 
                    color="#26abff" 
                    :stroke-width="10" 
                    :percentage="item.LastProgress_actualratio">
                  </el-progress>
                  <el-progress 
                    class="finish-loading finish-loading-lastactual" 
                    :show-text="false"  
                    :text-inside="true" 
                    color="#ffb224" 
                    :stroke-width="10" 
                    :percentage="item.Progress_actualratio">
                  </el-progress>
                </el-col>
              </el-row>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content-right progress-right-bim">
      <progressLoading></progressLoading>
    </div>
  </div> 
</template>

<script>
import WaterBall from '../common/WaterBall'
import progressTab from '../imageProgress/projectTab'
import vueSeamlessScroll from 'vue-seamless-scroll'
import progressLoading from '../imageProgress/progressLoading'
export default {
  name: "ImageProgress",
  components: {
    WaterBall,
    progressTab,
    vueSeamlessScroll,
    progressLoading,
  },
  data() {
    return {
      seriesDataBallShow: false,
      seriesDataBall: 0,  // 球的占比
      countDay: '', // 倒计时天数
      lagList: [], // 左侧--进度滞后原因
      finishList: [], // 左侧--完成情况
      arrayTwo: [],
      projectKey: '1',
    };
  },
  props: {
    
	},
  mounted() {
    this.projectKey = window.localStorage.getItem("project") || "1";
    this.getimageProgerssAxios();
    this.imgProgressstimer = setInterval(() => {
      this.getimageProgerssAxios()
    }, 5000)
    let now = this.$formatData.dateInit(new Date())
    let oDate1, oDate2, iDays;
      oDate1 = new Date(now).getTime()
      oDate2 = new Date(this.$project.projectData.endDate).getTime()
      iDays = parseInt((oDate1 - oDate2) / 1000 / 60 / 60 / 24)
    if(iDays > 0){
      this.countDay = '0'
    }else{
      this.countDay = this.$formatData.DateDiff(now, this.$project.projectData.endDate)
    }
    window.addEventListener('resize', this.handleResize)
    if(window.frameElement != null){ //iframe
      window.frameElement.addEventListener("onresize", this.handleResize);
    }
  },
  methods: {
    getimageProgerssAxios(){
      let _this = this;
      let url = `${window.pubilc_config.webserverurl}/api/Daxing/Daxing/`
      
      _this.$axios
        .get(url + 'GetprogressNew')
        .then(res3=>{
          if (res3.status == 200) {
            let res3_data = res3.data;
            // 返回的是施工进度工程进度的信息
            let changedata = res3_data;

            let arrall = []
            res3_data.forEach((item,index)=>{ 
              // let _datarate = (
              //   item.progress_build + 
              //   item.progress_steelwork + 
              //   item.progress_canopy + 
              //   item.progress_second + 
              //   item.progress_wall + 
              //   item.progress_electrical + 
              //   item.progress_decorate + 
              //   item.progress_services
              // ) / 8 

              // let ctype = this.$project.projectData.constructionType
              // let total = 0
              // for(let a of ctype) {
              //   total += item[`progress_${a.field}`]
              // }
              // let _datarate = total / ctype.length
              
              let total = 0
              for(let data of item.file_date) {
                total += parseInt(data.progress_Value)
              }
              let _datarate = total / item.file_date.length

              changedata[index].datarate =  _datarate.toFixed(0) * 1
              arrall.push( _datarate.toFixed(0) * 1)
            })
            // arrayAverage是求数组平均值， 工程总进度完成比为四个子项完成比的平均值
            let arrayAverage = arr0 => arr0.reduce((acc, val) => acc + val, 0) / arr0.length;
            let allprogress_total = arrayAverage(arrall).toFixed(0) * 1

            _this.seriesDataBallShow = true;
            _this.seriesDataBall = allprogress_total;
            
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getprogress')
        })

      _this.$axios
        .get(url+'GetPregress')
        .then(res=>{
          if (res.status == 200) {
            let res_data = res.data;
            _this.finishList = res_data;
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/GetPregress')
        })

      _this.$axios
        .get(url+'Getlag')
        .then(res=>{
          if (res.status == 200) {
            _this.lagList = []; // 每次调用前先清空

            let res_data = res.data;
            res_data.forEach(item => {
              _this.lagList.push(item.danger_name)
            })
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getlag')
        })
    },
    handleResize() {
      this.$refs.waterBall.handleResize()
    }
  },
  watch: {},
  computed: {
    classOption () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  }, 
  destroyed () {
    clearTimeout(this.imgProgressstimer)
    window.removeEventListener('resize', this.handleResize)
    if(window.frameElement != null){ //iframe
      window.frameElement.removeEventListener("onresize", this.handleResize);
    }
  }

};
</script>

<style lang="scss" scoped>
.content-left{
  overflow-x: auto !important;
}
.progress-left{
  margin: 20px 20px 5px;
  
  .overviwe-title{
    margin-bottom: 10px;
  }
  .progress-state{ 
    font-weight: 500;
    font-family: SourceHanSansCN;
    .progress-word{
      margin: 8px 0px 8px 30px;
      display: inline-block; 
      p{
        line-height: 34px;
      }
      .font-22{
        font-size: 22px;
        font-family: AlibabaPuHuiTi;
      }
    }
    .progress-echart{ 
      float: right;
      margin-right: 30px;
      text-align:right;
      align-items: end;
    }
  }
  .progress-lag{
    padding-bottom: 20px;
    .seamless-warp{
      height: 190px;
      overflow: hidden;
      .font-width{
        display: inline-block;
        width: 40px;
      }
    }
    ul{
      margin: 0 0px 0px 30px;
      padding: 20px 0 0 0;
      max-height: 130px;
      overflow-y: auto;
      li{
        line-height: 20px;
        padding-top: 8px;
        .list-num{
          display: inline-block;
        }
      }
    }
  }
  .project-finish{
    .lag-list-title{
      margin: 20px 10px 0 20px;
    }
    ul{
      margin: 0 10px 0 20px;
      padding-bottom:40px;
      max-height: 170px;
      overflow-x: auto;
      li{
        span{
          padding-right: 4px;
        }
      }
    }
    .finish-loading{
      width: 80px;
      display: inline-block;
      /deep/ .el-progress-bar .el-progress-bar__outer{
        background-color: #1b283d !important;
      }
      /deep/ .el-progress-bar__outer,/deep/ .el-progress-bar .el-progress-bar__inner{
        border-radius: 0 !important;
      }
      
    }
    .finish-loading-actual{
      display: inline-block;
      position: absolute;
      top: 4px;
      right: 0;
      z-index: 9;
      /deep/ .el-progress-bar .el-progress-bar__outer{
        background-color: transparent !important;
      }
    }
    .finish-loading-lastactual{
      position: absolute;
      top: 4px;
      right: 0;
      z-index: 8;
      width: 80px;
      
    }
  }
}
.bg-height-230{
  height: 240px;
}
</style>